import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Spinner,
  Alert,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import CrearLista from "views/Crea/CreaLista";
import ProtectedRoute from "./Protected";

const ListaChequeo = () => {
  const [list1, setList1] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actualizando, setActualizando] = useState(false);
  const [error, setError] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const urlObtener =
    "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerListasVigentes";

  const urlActualizar =
    "https://inspecciongnvback.azurewebsites.net/api/v1/ActualizaLista";

  const auth = {
    username: "admin.icontec@icontec.org",
    password: "quAngEraMuSTerGerEDE",
  };

  const obtenerListas = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(urlObtener, {
        auth,
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
      });

      setList1(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error obteniendo las listas:", error);

      setError(
        error?.response?.data?.message ||
          "No fue posible obtener las listas de chequeo.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    obtenerListas();
  }, [obtenerListas]);

  const actualizarLista = async (item, nuevoVigente) => {
    const accion = nuevoVigente ? "activar" : "desactivar";

    const resultado = await Swal.fire({
      title: `¿Desea ${accion} esta lista?`,
      html: `
        <div style="text-align: left;">
          <p><strong>ID:</strong> ${item.id}</p>
          <p><strong>Lista:</strong> ${item.nombre || "Sin nombre"}</p>
          <p><strong>Estado actual:</strong> ${
            item.vigente ? "Vigente" : "No vigente"
          }</p>
          <p><strong>Nuevo estado:</strong> ${
            nuevoVigente ? "Vigente" : "No vigente"
          }</p>
        </div>
      `,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!resultado.isConfirmed) {
      return;
    }

    try {
      setActualizando(true);

      const response = await axios.put(
        `${urlActualizar}?Id=${item.id}`,
        {
          Nombre: item.nombre,
          Vigente: nuevoVigente,
        },
        {
          auth,
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Actualización exitosa",
        text:
          response?.data?.message ||
          `La lista fue ${nuevoVigente ? "activada" : "desactivada"} correctamente.`,
        confirmButtonText: "Aceptar",
      });

      await obtenerListas();
    } catch (error) {
      console.error("Error actualizando la lista:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.message ||
          `No fue posible ${accion} la lista.`,
        confirmButtonText: "Aceptar",
      });
    } finally {
      setActualizando(false);
    }
  };

  const handleGestionCuestionario = (id) => {
    window.location.href = `/admin/Cuestionario/${id}`;
  };

  const totalPages = Math.ceil(list1.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = list1.slice(indexOfFirstItem, indexOfLastItem);

  const cambiarPagina = (page) => {
    if (page < 1 || page > totalPages) {
      return;
    }

    setCurrentPage(page);
  };

  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  return (
    <ProtectedRoute>
      <Header />

      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h3 className="mb-0">Listas de chequeo</h3>
                    <small className="text-muted">
                      Total de listas: {list1.length}
                    </small>
                  </div>

                  <Button
                    color="secondary"
                    size="sm"
                    onClick={obtenerListas}
                    disabled={loading || actualizando}
                  >
                    <i className="fas fa-sync-alt mr-2" />
                    Actualizar
                  </Button>
                </div>
              </CardHeader>

              <div className="text-center py-3">
                <CrearLista />
              </div>

              {error && (
                <div className="px-4">
                  <Alert color="danger">{error}</Alert>
                </div>
              )}

              {loading ? (
                <div className="text-center py-5">
                  <Spinner color="primary" />
                  <div className="mt-2 text-muted">
                    Cargando listas de chequeo...
                  </div>
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">LISTA DE CHEQUEO</th>
                      <th scope="col">TIPO ORDEN SERVICIO</th>
                      <th scope="col">VERSIÓN</th>
                      <th scope="col">VIGENTE</th>
                      <th scope="col">ACCIONES</th>
                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.length > 0 ? (
                      currentItems.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>

                          <td>
                            <strong>{item.nombre || "Sin nombre"}</strong>
                          </td>

                          <td>{item.tipoOrdenSerivicioId}</td>

                          <td>{item.version}</td>

                          <td>
                            {item.vigente ? (
                              <span className="badge badge-success">
                                Vigente
                              </span>
                            ) : (
                              <span className="badge badge-secondary">
                                No vigente
                              </span>
                            )}
                          </td>

                          <td>
                            <div className="d-flex align-items-center">
                              <Button
                                color="info"
                                size="sm"
                                className="mr-2"
                                onClick={() =>
                                  handleGestionCuestionario(item.id)
                                }
                                disabled={actualizando}
                              >
                                <i className="fas fa-list mr-1" />
                                Cuestionario
                              </Button>

                              <Button
                                color={item.vigente ? "warning" : "success"}
                                size="sm"
                                onClick={() =>
                                  actualizarLista(item, !item.vigente)
                                }
                                disabled={actualizando}
                              >
                                <i
                                  className={`fas ${
                                    item.vigente
                                      ? "fa-toggle-off"
                                      : "fa-toggle-on"
                                  } mr-1`}
                                />

                                {item.vigente ? "Desactivar" : "Activar"}
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-5">
                          <i className="fas fa-inbox fa-2x text-muted mb-3" />
                          <div className="text-muted">
                            No hay listas de chequeo disponibles.
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}

              {totalPages > 0 && (
                <CardFooter className="py-4">
                  <nav aria-label="Paginación">
                    <Pagination
                      className="pagination justify-content-end mb-0"
                      listClassName="justify-content-end mb-0"
                    >
                      <PaginationItem disabled={currentPage === 1}>
                        <PaginationLink
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            cambiarPagina(currentPage - 1);
                          }}
                        >
                          <i className="fas fa-angle-left" />
                          <span className="sr-only">Anterior</span>
                        </PaginationLink>
                      </PaginationItem>

                      {Array.from(
                        { length: totalPages },
                        (_, index) => index + 1,
                      ).map((page) => (
                        <PaginationItem
                          active={page === currentPage}
                          key={page}
                        >
                          <PaginationLink
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              cambiarPagina(page);
                            }}
                          >
                            {page}
                          </PaginationLink>
                        </PaginationItem>
                      ))}

                      <PaginationItem disabled={currentPage === totalPages}>
                        <PaginationLink
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            cambiarPagina(currentPage + 1);
                          }}
                        >
                          <i className="fas fa-angle-right" />
                          <span className="sr-only">Siguiente</span>
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </nav>
                </CardFooter>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </ProtectedRoute>
  );
};

export default ListaChequeo;
